export const telephone = {
  domestic: {
    label: 'United States telephone number',
    extension: {
      label: 'Extension',
    },
  },
  DSN: {
    label: 'DSN telephone number',
    extension: {
      label: 'Extension',
    },
  },
  international: {
    label: 'International telephone number',
    extension: {
      label: 'Extension',
    },
  },
  noNumber: {
    label: "I don't know",
  },
  type: {
    domestic: 'United States number',
    international: 'International number',
    DSN: 'DSN number',
  },
  timeOfDay: {
    day: 'Day only',
    night: 'Night only',
    both: 'Both',
  },
  numberType: {
    title: 'Select phone number type',
    cell: 'Cell',
    home: 'Home',
    work: 'Work',
    other: 'Other',
  },
  phoneNumbers: {
    title: 'What is this person\'s phone number? (You may list more than one.)',
    branch: {
      title: 'Can you provide their phone number?',
    },
    summary: {
      title: 'Summary of phone numbers',
    },
    append: 'Add another phone number',
  },

  aria: {
    domestic: 'Switch to United States number',
    international: 'Switch to international number',
    DSN: 'Switch to DSN number',
    countryCode: 'Country code for international phone number',
    phoneNumber: 'International phone number',
    domesticAreaCode: 'Area code for United States phone number',
    domesticThree: 'First three of the United States phone number',
    domesticFour: 'Last four of the United States phone number',
    DSNAreaCode: 'Area code for the DSN phone number',
    DSNThree: 'First three of the DSN phone number',
    DSNFour: 'Last four of the DSN phone number',
    extension: 'Extension',
    day: 'Day only',
    night: 'Night only',
    both: 'Both day and night',
    cell: 'This telephone number is a cell phone',
    home: 'This telephone number is a home phone',
    work: 'This telephone number is a work phone',
    other: 'This telephone number is a type not listed',
  },
};
